// extracted by mini-css-extract-plugin
export default {"address":"Address_address__DK2iy","mailLink":"Address_mailLink__pIMtr"};